import React from "react";

const QuranCommandsTop = ({
  isVisible,
  uiLabels,
  surahMenuOpen,
  chapters,
  onOpenSettings,
  onOpenSearch,
  onOpenSurahSelector,
  onSelectSurah,
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div
      className="quran-commands-top"
      dir="ltr"
      onClick={(event) => event.stopPropagation()}
      onPointerUp={(event) => event.stopPropagation()}
    >
      <button
        type="button"
        className="quran-icon-btn quran-commands-btn"
        aria-label={uiLabels.settings}
        title={uiLabels.settings}
        onClick={onOpenSettings}
      >
        <i className="bi bi-gear-fill quran-settings-icon" aria-hidden="true" />
      </button>

      <div className="quran-commands-search-wrap">
        <button
          type="button"
          className="quran-icon-btn quran-commands-btn"
          aria-label={uiLabels.search}
          title={uiLabels.search}
          onClick={onOpenSearch}
        >
          <i className="bi bi-search quran-search-trigger-icon" aria-hidden="true" />
        </button>
      </div>

      <div className="quran-commands-surah-wrap">
        <button
          type="button"
          className="quran-icon-btn quran-commands-btn"
          aria-label={uiLabels.chapterList}
          title={uiLabels.chapterList}
          onClick={onOpenSurahSelector}
        >
          <span className="quran-icon-glyph">☰</span>
        </button>
        {surahMenuOpen && (
          <div className="quran-commands-panel">
            <select onChange={(event) => onSelectSurah(event.target.value)} defaultValue="">
              <option value="" disabled>
                {uiLabels.chapterLabel}
              </option>
              {(chapters || []).map((chapter) => (
                <option key={`chapter-${chapter.id}`} value={chapter.id}>
                  {chapter.id}. {chapter.name}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuranCommandsTop;
